module.exports = __webpack_public_path__ + "img/placeholder-icon.25372572.svg";